/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
  databaseName: z.string(),
});

export const GetClusterDatabaseSchema = {
  id: 'cluster-database.get',
  tag: 'Cluster',
  summary: 'Get cluster database schema',
  description: 'Retrieve a PostgreSQL database schema of a cluster',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/database/${params.databaseName}/schema`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(z.string().min(1)),
        },
      },
    },
  },
} as const satisfies Endpoint;
